{{!-- characteristic lines--}}
{{#each plotData}}
<g id=js-line-{{@index}} gradient="{{slope}}" class="click-overlay js-char-line">
	<path class="char-line"
		d="{{path}}" stroke-width="{{../plotData.strokeWidth}}" stroke="{{color}}"
		{{#unless ../readOnly}} opacity="{{opacity}}" {{/unless}} clip-path="{{clippath}}"
		fill="none" stroke-dasharray="{{../plotData.dashstyle}}"/>
	{{!-- click region (same graph as above with thicker lines and invisible) --}}
	<path d="{{path}}" class="click-overlay" stroke-width="20" stroke="{{color}}" opacity="0" clip-path="{{clippath}}" fill="none"/>
	<text class="click-overlay" x="{{label.x}}" y="{{label.y}}" fill="{{color}}"
		text-anchor="start"
		letter-spacing="-3px"
		font-size="40">{{label.text}}</text>

	{{!-- constant continuation of the slope characteristic--}}
	<line class="start char-line" x1="100" y1="{{start.y}}" x2="{{start.x}}" y2="{{start.y}}"
		stroke-dasharray="{{../plotData.dashstyle}}"
		stroke="{{color}}" stroke-width="{{../plotData.strokeWidth}}" opacity="{{start.show}}"/>
	<line class="end char-line" x1="{{end.x}}" y1="{{end.y}}" x2="1600" y2="{{end.y}}"
		stroke-dasharray="{{../plotData.dashstyle}}"
		stroke="{{color}}" stroke-width="{{../plotData.strokeWidth}}" opacity="{{end.show}}"/>
</g>
{{/each}}
